import type { ConfigType } from '@plone/registry';
import TalkView from '../components/Views/TalkView';
import DocumentView from '../components/Views/DocumentView';

export default function install(config: ConfigType) {
  // Keyed by the portal_type as the REST API reports it in `@type`.
  config.views.contentTypesViews.Talk = TalkView;
  config.views.contentTypesViews.Document = DocumentView;
  // Volto selects a layout view before a content-type view. Documents normally
  // use `document_view`, so register the wrapper for that layout as well.
  config.views.layoutViews.document_view = DocumentView;
  return config;
}
